import thinkingdata from "thinkingdata-browser";
import {
  ENV_THINKING_DATA_APP_ID,
  ENV_THINKING_DATA_SERVER_URL,
} from "./index";
import {
  getHashParams,
  getUid,
  getDeviceId,
  getDeviceType,
} from "@/utils/index";
import { getOpenid } from "@/utils/qwLogin";

/**
 *
 * @param param0 埋点配置
 * @returns
 */
export const getReporting = (
  data
  //     ?: {
  //   config: object,
  //   properties: {
  //     [stirng: string]: string | number,
  //     // 玩家设备id
  //     device_id: string,
  //     // 玩家设备类型 1-安卓 2-苹果 3-网页
  //     device_type: 1 | 2 | 3,
  //     // 事件触发时的时间 时区锁定utc+8
  //     event_time: string,
  //     // 客户端ip
  //     ip: string,
  //   },
  // }
) => {
  // console.log(ENV_THINKING_DATA_APP_ID, ENV_THINKING_DATA_SERVER_URL);

  const now = new Date();

  const _properties = {
    device_id: getDeviceId(),
    account_id: getOpenid(),
    device_type: getDeviceType(),
    utm_source: getHashParams("utm_source"),
    utm_medium: getHashParams("utm_medium"),
    utm_campaign: getHashParams("utm_campaign"),
    event_time: now.toUTCString(),
    channel: localStorage.getItem("channel"),
  };
  const { config, properties } = data || {};
  const ta = thinkingdata;

  ta.init({
    appId: ENV_THINKING_DATA_APP_ID,
    serverUrl: ENV_THINKING_DATA_SERVER_URL,
    autoTrack: {
      pageShow: false, // 开启页面展示事件，事件名ta_page_show
      pageHide: false, // 开启页面隐藏事件，事件名ta_page_hide
    },
    ...config,
  });
  ta.login(getOpenid());
  ta.setSuperProperties({ ..._properties, ...(properties || {}) });
  return ta;
};
